module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/1-295226e35e9f087e88a1b7b0af4f4a67.webp";